// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"48":"8aa20d3e4eb0a4f2","264":"a70b03dbdca13f82","304":"d363509c0dd3624d","472":"7c8cdf361d79a7d1","593":"f68620d9fb5ce57c","777":"ad60b7bcad0c5b9b","785":"3f2c7cf74cae29a7","916":"0368a5467a0035e1","954":"ef9e6df9c2f85bc1"}[chunkId] + ".js";
};